module.exports = __webpack_public_path__ + "static/media/mn8.49f147b4.jpeg";